
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Save } from "lucide-react";
import { useContactBook } from "@/hooks/contact/useContactBook";

interface SaveContactButtonProps {
  name: string;
  phone: string;
  email: string;
}

export const SaveContactButton = ({ name, phone, email }: SaveContactButtonProps) => {
  const { saveContact } = useContactBook();
  const [isSaving, setIsSaving] = useState(false);

  const handleSave = async () => {
    if (!name || !phone) return;
    
    setIsSaving(true);
    try {
      await saveContact(name, phone, email);
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <Button
      variant="outline"
      size="sm"
      onClick={handleSave}
      disabled={!name || !phone || isSaving}
    >
      <Save className="h-4 w-4 mr-2" />
      Save Contact
    </Button>
  );
};
